/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, UseQueryResult, useQuery } from "@tanstack/react-query";
import { getLocodes } from "api/services/common";
import { GetLocodesResponseType } from "api/response";
import { commonQueryKeys } from "./commonQueryKeys";

export function useGetLocodes<T = GetLocodesResponseType>(
  country: number,
  options?: UseQueryOptions<GetLocodesResponseType, unknown, T>,
): UseQueryResult<T> {
  return useQuery<GetLocodesResponseType, unknown, T>({
    queryKey: commonQueryKeys.locodes(country),
    queryFn: () => getLocodes(country).then((res) => res.data),
    enabled: !!country,
    refetchOnMount: false,
    ...options,
  });
}
